var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// removed import of scss-style
import { observer } from 'mobx-react';
import RadioButton from '../radio-button/RadioButton';
import RadioButtonWithAttachment from '../radio-button-with-attachment/RadioButtonWithAttachment';
let RadioButtonGroup = class RadioButtonGroup extends React.Component {
    constructor(props) {
        super(props);
        this.onClearAttachmentHandler = () => {
            this.props.data.items
                .filter((obj) => obj.hasAttachment)
                .forEach((obj) => {
                obj.attachmentValue = null;
            });
        };
        this.onFileChangeHandler = (e) => {
            this.props.data.items
                .filter((obj) => obj.hasAttachment)
                .forEach((obj) => {
                obj.attachmentValue = e.currentTarget.files;
            });
        };
        this.checkRadioButton = (index) => {
            this.props.data.selected = index;
            this.forceUpdate();
        };
    }
    render() {
        const rest = __rest(this.props, []);
        return (React.createElement("div", Object.assign({ className: "NewReportOrder__BlockSpace--medium RadioButtonGroup" }, rest), this.props.data.items.map((item, index) => {
            if (item.hasAttachment) {
                return (React.createElement(RadioButtonWithAttachment, { name: this.props.name, label: item.label, value: index.toString(), key: index.toString(), onFileChangeHandler: this.onFileChangeHandler, onChangeHandler: () => this.checkRadioButton(index), onClearAttachment: this.onClearAttachmentHandler, attachmentValue: item.attachmentValue, attachmentLabel: item.attachmentLabel, checked: index === this.props.data.selected }));
            }
            return (React.createElement(RadioButton, { name: this.props.name, label: item.label, value: index.toString(), key: index.toString(), onChangeHandler: () => this.checkRadioButton(index), checked: index === this.props.data.selected }));
        })));
    }
};
RadioButtonGroup = __decorate([
    observer
], RadioButtonGroup);
export default observer(RadioButtonGroup);
